module.exports = __webpack_public_path__ + "static/img/RAPD600_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPD600_1.png
// module id = AxAC
// module chunks = 0